<template lang="pug">
div(style="padding: 60px 25px;")
    BotPageTitle(style="margin-top: 0; margin-left: -2px; padding: 0; font-size: 53px; font-weight: 400; text-align: left; color: #515151; letter-spacing: normal;")
    h3(:style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '' }", style="margin: 0 0 20px 0; font-weight: 400; color: #515151")
      | {{ $t('simplifiedEditing.subtitle.chooseWorkspaceToEdit') }}
    div.md-layout(style="padding-left: 0;")
      div(style="display: flex; flex-wrap: wrap; gap: 10px;" v-for="workspace in workspaces" )
        WorkspaceSimpleCard( :key="workspace.id" :workspace="workspace")
</template>

<script>
import BotPageTitle from '@/components/BotPageTitle.vue'
import WorkspaceSimpleCard from '@/components/WorkspaceSimpleCard'

import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'Workspaces',
  components: { BotPageTitle, WorkspaceSimpleCard },
  computed: {
    ...mapFields('selectedAssistant', ['assistantId']),
    ...mapGetters('workspaces', ['workspaces', 'active'])
  },
  created () {
    if (typeof this.assistantId === typeof null) {
      Swal.fire({
        text: this.$t('canalInstagram.pleaseSelectCognitiveAssistant'),
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
      this.$router.push('/lista-assistentes')
    }
    this.$store.dispatch('workspaces/populate')
  }
}
</script>
